import { Directive, HostListener, Input } from '@angular/core';
import { AuthLinkType } from 'src/app/enums/event/event-data.enum';
import { AuthEventType } from 'src/app/enums/event/event.enum';
import { LinkClick } from 'src/app/models/event-data.model';
import { EventTrackingService } from 'src/app/services/event-tracking.service';

@Directive({
    selector: 'a[eevTrackClick], button[eevTrackClick], app-verification-tips-panel[eevTrackClick]',
    standalone: false
})
export class EEVTrackClickDirective {
  constructor(private readonly eventTrackingService: EventTrackingService) { }

  @Input() eevTrackClick: AuthLinkType;

  @HostListener('click', ['$event.target'])
  public onClick(anchor: HTMLAnchorElement): void {
    if (this.eevTrackClick) {
      this.eventTrackingService.trackEvent<LinkClick>(AuthEventType.LINK_CLICK, {
        authClickLinkText: anchor.innerText,
        authClickLinkType: this.eevTrackClick,
      });
    }
  }
}
